import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { BaseCrudComponent } from '../../base';

@Component({
  selector: 'upload-anexos',
  templateUrl: './upload-anexos.component.html'
})
export class UploadAnexosComponent extends BaseCrudComponent implements OnInit {

  @Input() label: string;
  @Input() listaAnexo: any[];

  @Output() listaAnexoChange = new EventEmitter<any[]>();

  ngOnInit(): void {
    this.listaAnexoChange.emit(this.listaAnexo);
  }

  selecionaArquivo(event) {
    for (const file of event.files) {
      if (file.name.match(/.pdf/) || file.name.match(/.jpg/) || file.name.match(/.png/) || file.name.match(/.PDF/) || file.name.match(/.JPG/) || file.name.match(/.PNG/)) {
        this.IncluirArquivo(file, this.listaAnexo, this.listaAnexoChange, { id_gerenciar_atividade: 0, tipo: 1 })
      }
    }
  }

  removeElementList(value: any) {
    this.listaAnexo.forEach((item, index) => {
      if (item.nome_arquivo === value.file.name && item.id < 1) {
        super.removeFromList(this.listaAnexo, this.listaAnexoChange, index, 'anexos');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/Componentes/upload-anexos/upload-anexos.component.ts